module.exports = __webpack_public_path__ + "media/images/return-hub-2ae324f638a2900832697498910db2f4.png";